<template>
  <div class="dropdown" @click="showDrop">
    <slot name="dropdown__wrapper">

    </slot>
    <slot name="drop-down-item">

    </slot>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  methods: {
    showDrop() {
      this.$emit("showDrop")
    },
  },
}
</script>

<style scoped>
.dropdown {
  position: relative;
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.dropdown__wrapper {
   min-width: 17rem;
   height: 4rem;
   background: #fff;
   border: .1rem solid #e6e6e6;
   padding: 0 4.8rem 0 2rem;
   display: flex;
   position: relative;
   align-items: center;
   border-radius: .4rem;
   box-shadow: 0 .2rem .4rem 0 rgba(0,0,0,.05);
   transition-property: all;
   transition-duration: .3s;
   transition-property: border-color,box-shadow;
 }
.dropdown .dropdown__wrapper {
  padding: 0 4.7rem 0 1.9rem;
  border: 0.2rem solid #80ba27;
}
.dropdown .dropdown__wrapper {
  border: 0;
  padding: 0 2rem 0 2.5rem;
}
.dropdown .dropdown__wrapper {
  border: 0;
  min-width: 0;
  padding: 0 2rem 0 2.5rem;
  background: transparent;
  box-shadow: 0 0 0 0 transparent;
}


</style>



// WEBPACK FOOTER //
// src/components/DropDown.vue